import React, { useContext, useState } from "react";
import { observer } from "mobx-react";
import Slider from "react-slick";
import { QuickPlayWebSettings } from "@utils/quick-play/slider";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { OfferStoreContext } from "@gp/components";
import BettingTipsListItem from "./BettingTipsListItem";

export default observer(function BettingTipsEventList() {
	const [isDragging, setIsDragging] = useState(false);

	const store = useContext(OfferStoreContext) as
		| AdditionalOfferViewStore
		| EventViewStore;

	const data = store.bettingTipsStore.bettingTips;

	const settings = {
		...QuickPlayWebSettings,
		infinite: data.length > 3,

		slidesToShow: (() => {
			if (store instanceof EventViewStore) {
				return 2;
			} else if (store instanceof AdditionalOfferViewStore) {
				return 1;
			} else {
				return 3;
			}
		})(),

		slidesToScroll: (() => {
			if (store instanceof EventViewStore) {
				return 2;
			} else if (store instanceof AdditionalOfferViewStore) {
				return 1;
			} else {
				return 3;
			}
		})(),
		beforeChange: () => setIsDragging(true),
		afterChange: () => setIsDragging(false),
	};

	return (
		<div className="card--carousel card--carousel--bbp">
			<div className="card--carousel__body u-padd--reset">
				<Slider
					{...settings}
					className="carousel carousel--most carousel--arrows carousel--arrows--sml"
				>
					{data.map((tip, index) => (
						<div
							key={tip.id}
							className="carousel__item carousel--most__item"
						>
							<BettingTipsListItem
								isDragging={isDragging}
								key={tip.id}
								data={tip}
								index={index}
								activatePopup={
									store.bettingTipsStore.activatePopup
								}
							/>
						</div>
					))}
				</Slider>
			</div>
		</div>
	);
});
